export default "__VITE_IMAGE_ASSET__6bdb2447__";